/*
 * File: PageHeader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:37:54 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { Col, Divider, Row, Typography } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { useGetDimensions } from 'hooks/useGetDimensions';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { Link } from 'react-router-dom';
import { useAppSelector } from 'redux/store';
import { ReactComponent as MdsiLogo } from '../../common/assets/mdsi-logo.svg';
import { UserDropdown } from './UserDropdown';

export const PageHeader = (): JSX.Element => {
  const { user, acuityContext } = useAppSelector((state) => state.app);
  const { xs } = useBreakpoint();
  const { width } = useGetDimensions();
  const isMdsiEmployee = user ? user['https://acuity.mdsiinc.com/user/user_metadata'].is_mdsi_employee : null;

  const styles: InlineStylesModel = {
    container: {
      alignItems: 'center',
      maxWidth: 1920,
      flex: 1,
      padding: width > 1920 ? '0 50px 0 30px' : 0
    },
    appName: {
      display: 'flex',
      cursor: 'pointer',
      color: '#84859a',
      alignItems: 'flex-end',
      flex: 1
    },
    mainContainer: {
      color: 'white'
    },
    link: {
      color: '#84859a'
    },
    userMenu: {
      fontSize: '15px'
    }
  };

  return (
    <Row style={styles.container} gutter={[16, 16]}>
      <Col style={styles.appName}>
        <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL} style={styles.link}>
          <MdsiLogo height="18" width="85" />
        </a>
        {!xs && (
          <a href={process.env.REACT_APP_ERNIE_REDIRECT_URL}>
            <Typography.Paragraph style={{ fontWeight: 'normal', color: 'gray', margin: 0, fontSize: '24px' }}>Acuity</Typography.Paragraph>
          </a>
        )}
        <Divider type="vertical" style={{ backgroundColor: 'gray', width: 2, height: 20 }} />
        <Link to={isMdsiEmployee ? '/internal' : `${acuityContext?.selectedCustomer.id}/projects`} style={styles.link}>
          <Typography.Paragraph style={{ fontWeight: 'normal', color: 'gray', margin: 0, fontSize: '24px' }}>Projects and Tasks</Typography.Paragraph>
        </Link>
      </Col>
      <Col>
        <Row align="middle" style={styles.userMenu}>
          {!xs && user?.name?.toUpperCase()}
          <UserDropdown />
        </Row>
      </Col>
    </Row>
  );
};
